module.exports = "https://static.wagwalking.com/_next/static/images/featured-providers-mobile-07851dafe7effd2349320be722369a63.png";